/**
 * @generated SignedSource<<8507a2199130298ff43f4b2fe7ba5fc9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TreeStateStatus = "finished" | "started" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SingleTreeStateScreen_TreeStateFragment$data = {
  readonly definition: {
    readonly status: TreeStateStatus;
  };
  readonly id: string;
  readonly progressPercentage: number;
  readonly rootNode: {
    readonly structureDefinition: {
      readonly title: string;
    };
  };
  readonly startedAt: string;
  readonly user: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectUserDescription_UserFragment">;
  } | null | undefined;
  readonly " $fragmentType": "SingleTreeStateScreen_TreeStateFragment";
};
export type SingleTreeStateScreen_TreeStateFragment$key = {
  readonly " $data"?: SingleTreeStateScreen_TreeStateFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SingleTreeStateScreen_TreeStateFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SingleTreeStateScreen_TreeStateFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progressPercentage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TreeNode",
      "kind": "LinkedField",
      "name": "rootNode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "structureDefinition",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "definition",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProjectUserDescription_UserFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TreeState",
  "abstractKey": null
};
})();

(node as any).hash = "6931dcdacefc49fa31a875445cf45fbd";

export default node;
